/* AntRx Lander Quiz — extracted scripts
 * Auto-generated 2026-05-08 from sections/antrx-lander-quiz.liquid
 * Do not edit directly; edit the source then re-run the extraction script.
 */

/* ─────────────────────────────────────────────────────────────
     Variant map - device count (1–15) → Shopify variant info
     Hardcoded in index.html local preview. In production Liquid,
     this is rendered server-side from product.variants.
     ───────────────────────────────────────────────────────────── */
  // AntRx product GID: gid://shopify/Product/8263489880111 (handle: antrx-keeps-ants-away-ultrasonic-repeller)
  // Variant IDs + prices fetched from Shopify Admin API 2026-05-07. SKUs unchanged.
  // Variant titles in Shopify still read "RodentRx" (cosmetic Shopify-side data quirk; doesn't affect cart behavior).
  window.VARIANT_MAP_BY_COUNT = {
    "1":  { id: 45319855177775, sku: "HPRX-ULTRA-V01-01PK", price: "$44.95",  label: "1-Pack" },
    "2":  { id: 45319855308847, sku: "HPRX-ULTRA-V01-02PK", price: "$79.90",  label: "2-Pack" },
    "3":  { id: 45319855243311, sku: "HPRX-ULTRA-V01-03PK", price: "$104.85", label: "3-Pack" },
    "4":  { id: 45319855341615, sku: "HPRX-ULTRA-V01-04PK", price: "$115.80", label: "4-Pack" },
    "5":  { id: 45319855210543, sku: "HPRX-ULTRA-V01-05PK", price: "$119.75", label: "5-Pack" },
    "6":  { id: 45319855374383, sku: "HPRX-ULTRA-V01-06PK", price: "$137.70", label: "6-Pack" },
    "7":  { id: 45319855407151, sku: "HPRX-ULTRA-V01-07PK", price: "$153.65", label: "7-Pack" },
    "8":  { id: 45319855439919, sku: "HPRX-ULTRA-V01-08PK", price: "$167.60", label: "8-Pack" },
    "9":  { id: 45319855472687, sku: "HPRX-ULTRA-V01-09PK", price: "$179.55", label: "9-Pack" },
    "10": { id: 45319855276079, sku: "HPRX-ULTRA-V01-10PK", price: "$195.00", label: "10-Pack" },
    "11": { id: 45319855505455, sku: "HPRX-ULTRA-V01-11PK", price: "$214.50", label: "11-Pack" },
    "12": { id: 45319855538223, sku: "HPRX-ULTRA-V01-12PK", price: "$234.00", label: "12-Pack" },
    "13": { id: 45319855570991, sku: "HPRX-ULTRA-V01-13PK", price: "$253.50", label: "13-Pack" },
    "14": { id: 45319855603759, sku: "HPRX-ULTRA-V01-14PK", price: "$273.00", label: "14-Pack" },
    "15": { id: 45319855636527, sku: "HPRX-ULTRA-V01-15PK", price: "$292.50", label: "15-Pack" }
  };

/* ─── extracted block boundary ─── */

// Topbar slider on mobile only - fades one message at a time.
  // Desktop (>=720px) shows all messages inline via CSS; slider is a no-op.
  (function() {
    var MOBILE_MAX = 1000;
    var msgs = document.querySelectorAll('.topbar-msg');
    if (msgs.length < 2) return;

    var idx = 0;
    var timer = null;

    function show(i) {
      msgs.forEach(function(m, j) {
        m.classList.toggle('is-active', j === i);
      });
    }

    function start() {
      if (timer) return;
      show(0);
      idx = 0;
      timer = setInterval(function() {
        idx = (idx + 1) % msgs.length;
        show(idx);
      }, 5000);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      // desktop: CSS handles display of all messages; ensure no JS state fights it
      msgs.forEach(function(m) { m.classList.remove('is-active'); });
    }

    function sync() {
      if (window.innerWidth < MOBILE_MAX) start();
      else stop();
    }

    sync();
    window.addEventListener('resize', sync);
  })();

  function toggleFaq(item) {
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(f) { f.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  }

  // See-more reviews — mobile reveals 3 at a time, desktop reveals 5 at a time.
  // Mobile starts with 3 visible (cards 1-3); cards 4-6 carry .ugc-card-mobile-hidden.
  // Desktop starts with 6 visible (cards 1-6); cards 7+ carry .ugc-card-hidden.
  // Reveal priority on mobile: drain mobile-hidden first, then fall through to globally hidden.
  function showMoreReviews() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
    var batchSize = isMobile ? 3 : 5;
    var revealed = 0;

    if (isMobile) {
      var mobileHidden = document.querySelectorAll('.ugc-card.ugc-card-mobile-hidden');
      for (var i = 0; i < mobileHidden.length && revealed < batchSize; i++) {
        mobileHidden[i].classList.remove('ugc-card-mobile-hidden');
        revealed++;
      }
    }
    if (revealed < batchSize) {
      var hidden = document.querySelectorAll('.ugc-card.ugc-card-hidden');
      for (var j = 0; j < hidden.length && revealed < batchSize; j++) {
        hidden[j].classList.remove('ugc-card-hidden');
        revealed++;
      }
    }
    updateSeeMoreCount();
    if (typeof gtag === 'function') {
      try { gtag('event', 'reviews_expanded', { batch_revealed: revealed, viewport: isMobile ? 'mobile' : 'desktop' }); } catch(e) {}
    }
  }
  function updateSeeMoreCount() {
    var wrap = document.getElementById('ugc-see-more-wrap');
    if (!wrap) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
    var hidden = document.querySelectorAll('.ugc-card.ugc-card-hidden').length;
    if (isMobile) {
      hidden += document.querySelectorAll('.ugc-card.ugc-card-mobile-hidden').length;
    }
    if (hidden === 0) { wrap.style.display = 'none'; }
    else { wrap.style.display = ''; }
  }
  // Recompute the see-more button visibility on viewport flip (rotate / dev tools resize)
  if (window.matchMedia) {
    var mql = window.matchMedia('(max-width: 639px)');
    if (mql.addEventListener) { mql.addEventListener('change', updateSeeMoreCount); }
    else if (mql.addListener) { mql.addListener(updateSeeMoreCount); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSeeMoreCount);
  } else {
    updateSeeMoreCount();
  }

  function toggleCalc(btn) {
    var panel = document.getElementById('calc-panel');
    var open = panel.classList.toggle('open');
    btn.textContent = open ? 'Hide coverage guide ↑' : 'Not sure how many units you need? →';
  }

  var calcVariantIndex = [0, 1, 2, 3]; // maps calc option to variant button index
  function calcResult(opt, variantIdx, html) {
    document.querySelectorAll('.calc-opt').forEach(o => o.style.background = '');
    opt.style.background = 'var(--gold-pale)';
    var result = document.getElementById('calc-result');
    result.innerHTML = '✓ ' + html;
    result.classList.add('show');
    // highlight the recommended variant
    var variants = document.querySelectorAll('.variant-btn');
    if (variants[variantIdx]) variants[variantIdx].click();
  }

  function switchImg(thumb, src) {
    document.querySelectorAll('.hero-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    document.getElementById('main-img').src = src;
  }

  var perDayMap = {'$44.95':'$0.12','$104.85':'$0.29','$119.75':'$0.33','$195.00':'$0.53'};

  function selectVariant(btn, price, was, save, perUnit) {
    document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    // update price display
    document.getElementById('price-main').textContent = price;
    document.getElementById('price-was').textContent = was;
    document.getElementById('price-save').textContent = 'Save ' + save;
    document.getElementById('price-per').textContent = perUnit + (perUnit.includes('23.95') ? ' - best value' : '');
    // update per-day cost
    var pd = perDayMap[price] || '';
    document.getElementById('price-per-day').innerHTML = pd ? 'That\'s <strong>' + pd + '/day</strong> for whole-home protection' : '';
    // update sticky with per-day
    var name = btn.querySelector('.variant-name').textContent;
    document.getElementById('sticky-price').innerHTML = (pd ? pd + '/day' : price) + '<small>' + name + (pd ? ' · ' + price + ' total' : '') + ' · Save ' + save + '</small>';
    // update + show variant confirmation chip
    var confirm = document.getElementById('variant-confirm');
    document.getElementById('variant-confirm-text').textContent = name + ' selected - ' + price;
    confirm.classList.add('show');
  }

  // Add selected variant to cart and redirect straight to checkout.
  // Uses Shopify's /cart/ URL format which adds + redirects in one step.
  // Works cross-origin (from landing pages hosted off-Shopify) and same-origin.
  function addToCartAndGo(overrideVariantId) {
    var variantId = overrideVariantId;

    if (!variantId) {
      var selected = document.querySelector('.variant-btn.selected');
      if (!selected) { selected = document.querySelector('.variant-btn.popular') || document.querySelector('.variant-btn'); }
      var pack = selected.getAttribute('data-pack') || '5';
      var map = window.VARIANT_MAP_BY_COUNT || {};
      var variant = map[pack];
      variantId = variant ? variant.id : null;
    }

    if (!variantId) { window.location.href = 'https://hellopest.org/checkout'; return; }

    // Disable all CTA buttons while redirect happens
    var btns = document.querySelectorAll('.btn-buy, .nav-cta, .vt-cta, .btn-dark, .sticky-cta-btn');
    btns.forEach(function(b) { b.style.pointerEvents = 'none'; b.style.opacity = '0.7'; });

    // Shopify direct-to-checkout URL: clears cart, adds variant, goes to checkout.
    // Note: previously appended ?checkout=1 — Shopify now rejects that with "expected String
    // to be a Hash: checkout" (broken 2026-05-08). Plain /cart/{variantId}:1 works correctly
    // and lands on a clean checkout page directly.
    window.location.href = 'https://hellopest.org/cart/' + variantId + ':1';
  }

  // "Stop the Ants" buttons (nav, sticky, footer):
  // - cart has items → go to /checkout
  // - otherwise → smooth-scroll to the quiz section
  window.__hasCartItems = false;
  (function() {
    if (location.protocol === 'file:') return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(cart) {
        if (cart && typeof cart.item_count === 'number') {
          window.__hasCartItems = cart.item_count > 0;
        }
      })
      .catch(function() {});
  })();
  function protectMyHomeClick(e) {
    e.preventDefault();
    if (window.__hasCartItems) {
      window.location.href = '/checkout';
      return;
    }
    var quiz = document.getElementById('quiz');
    if (quiz) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Sticky CTA: show after hero CTA leaves viewport, but hide while the
  // quiz section is on screen so the developing plan isn't obscured.
  (function() {
    var heroCta = document.querySelector('.hero-cta-stack');
    var quiz = document.getElementById('quiz');
    var stickyCta = document.querySelector('.sticky-cta');
    if (!heroCta || !stickyCta) return;
    function update() {
      if (window.innerWidth >= 900) { stickyCta.classList.remove('visible'); return; }
      var heroRect = heroCta.getBoundingClientRect();
      var pastHero = heroRect.bottom <= 0;
      var quizInView = false;
      if (quiz) {
        var qr = quiz.getBoundingClientRect();
        quizInView = qr.top < window.innerHeight && qr.bottom > 0;
      }
      if (pastHero && !quizInView) stickyCta.classList.add('visible');
      else stickyCta.classList.remove('visible');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  // Daily-drifting social-proof counts. Each day past the baseline, a small
  // deterministic number of new customers is added; a fraction of those
  // "leave reviews." Deterministic per calendar day so all occurrences on
  // the page show the same value and the count doesn't jitter within a visit.
  (function() {
    var BASELINE = { date: '2026-04-17', households: 11247, reviews: 2847 };
    var parts = BASELINE.date.split('-');
    var base = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var today = new Date();
    base.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    var days = Math.max(0, Math.floor((today - base) / 86400000));
    function rnd(n) {
      var t = (n + 0x6D2B79F5) | 0;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }
    var households = BASELINE.households;
    var reviews = BASELINE.reviews;
    for (var i = 1; i <= days; i++) {
      var newCustomers = 8 + Math.floor(rnd(i) * 11);
      var reviewFrac = 0.25 + rnd(i + 100000) * 0.10;
      households += newCustomers;
      reviews += Math.round(newCustomers * reviewFrac);
    }
    var hhNew = households.toLocaleString('en-US');
    var rvNew = reviews.toLocaleString('en-US');
    var hhOld = BASELINE.households.toLocaleString('en-US');
    var rvOld = BASELINE.reviews.toLocaleString('en-US');
    if (hhOld === hhNew && rvOld === rvNew) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v.indexOf(hhOld) === -1 && v.indexOf(rvOld) === -1) continue;
      node.nodeValue = v.split(hhOld).join(hhNew).split(rvOld).join(rvNew);
    }
  })();

/* ─── extracted block boundary ─── */

(function() {
  var QUESTIONS = {
    Q1: {
      text: "What's going on at your home right now?",
      options: [
        { id: 'A', text: 'I\u2019ve seen multiple ants - I have an active problem right now' },
        { id: 'B', text: "I had ants before and I don't want it to happen again" },
        { id: 'C', text: "I haven't had ants but I'm concerned - new home, new season, or a neighbor just had a problem" },
        { id: 'D', text: "I've tried things before - traps, sprays, other devices - and the problem keeps coming back" }
      ], multi: false
    },
    Q_STATE: {
      text: 'What state do you live in?',
      type: 'dropdown',
      options: [
        'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia',
        'Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland',
        'Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey',
        'New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina',
        'South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming','District of Columbia'
      ]
    },
    Q2: {
      text: 'What type of home do you live in?',
      options: [
        { id: 'A', text: 'Single-family house (no shared walls)' },
        { id: 'B', text: 'Townhouse or duplex (at least one shared wall)' },
        { id: 'C', text: 'Apartment or condo (multi-unit building)' },
        { id: 'D', text: 'Mobile or manufactured home' }
      ], multi: false
    },
    Q3: {
      text: 'Do you have a garage?',
      options: [
        { id: 'A', text: 'No garage' },
        { id: 'B', text: '1-car garage (1 bay, 1 garage door)' },
        { id: 'C', text: '2-car garage (2 bays)' },
        { id: 'D', text: '3-car garage or larger' }
      ], multi: false
    },
    Q3_APT: {
      text: 'What floor is your unit on?',
      options: [
        { id: 'A', text: 'Ground floor' },
        { id: 'B', text: 'Second floor or higher' }
      ], multi: false
    },
    Q3_MOB: {
      text: 'Does your home have a storage shed or detached structure attached by a walkway?',
      options: [
        { id: 'A', text: 'Yes' },
        { id: 'B', text: 'No' }
      ], multi: false
    },
    Q4: {
      text: 'How many exterior doors enter directly into your home\u2019s finished living space?',
      options: [
        { id: 'A', text: '1 exterior door' },
        { id: 'B', text: '2 exterior doors' },
        { id: 'C', text: '3 exterior doors' },
        { id: 'D', text: '4 or more exterior doors' }
      ], multi: false
    },
    Q4B: {
      text: 'Of those exterior doors, how many open directly into a kitchen, pantry, or eating area?',
      options: [
        { id: 'NONE', text: 'None of them open into one of those rooms' },
        { id: '1', text: '1 door opens into one of those rooms' },
        { id: '2', text: '2 doors open into those rooms' },
        { id: '3', text: '3 doors open into those rooms' },
        { id: '4', text: '4 or more doors open into those rooms' }
      ], multi: false,
      filterOptions: function(state) {
        var q4 = state.answers.Q4;
        var maxDoors = q4 === 'A' ? 1 : (q4 === 'B' ? 2 : (q4 === 'C' ? 3 : (q4 === 'D' ? 4 : 0)));
        return function(opt) {
          if (opt.id === 'NONE') return true;
          if (opt.id === '1') return maxDoors >= 1;
          if (opt.id === '2') return maxDoors >= 2;
          if (opt.id === '3') return maxDoors >= 3;
          if (opt.id === '4') return maxDoors >= 4;
          return false;
        };
      }
    },
    Q5_APT: {
      text: 'How many rooms are in your unit (not counting bathrooms)?',
      options: [
        { id: 'A', text: '1\u20133 rooms' },
        { id: 'B', text: '4\u20136 rooms' },
        { id: 'C', text: '7 or more rooms' }
      ], multi: false
    },
    Q5_MOB: {
      text: 'How would you describe the layout of your home?',
      options: [
        { id: 'A', text: 'Open plan \u2014 kitchen, living, and dining are all connected' },
        { id: 'B', text: 'Separated rooms with hallways' }
      ], multi: false
    },
    Q7: {
      text: 'How many rooms in your home have food prepared, stored, or eaten in them? Count kitchens, pantries, dining areas, and any basement food storage.',
      options: [
        { id: 'A', text: '1 room (kitchen only)' },
        { id: 'B', text: '2 rooms (e.g. kitchen + pantry, or kitchen + dining)' },
        { id: 'C', text: '3 rooms (kitchen + pantry + a dining or eating area)' },
        { id: 'D', text: '4+ rooms (kitchen, pantry, dining, plus a bar/breakfast nook/snack zone)' }
      ], multi: false
    },
    Q8: {
      text: 'Anything else describing what you\u2019re seeing? Select all that apply, or skip if none apply.',
      options: [
        { id: 'C', text: 'It\u2019s in multiple rooms' },
        { id: 'E', text: "I haven't found where they're coming in" },
        { id: 'F', text: 'Near a sink, bathroom, or other water source' }
      ], multi: true, allowZero: true
    },
  };

  var TEMPLATES = {
    ACTIVE_KITCHEN: {
      headline: 'Ants in the kitchen means they\u2019ve found a food source. Here\u2019s how to break the trail.',
      body: 'Your [N]-device plan creates two lines of defense: one at the entry points where scouts are getting in, and one in the kitchen where the trail leads. Place the kitchen device on the wall closest to where you\u2019ve seen the trail \u2014 usually along a baseboard or under the toe-kick of cabinets. Wipe the visible trail with a 1:1 vinegar-water solution to clean the surface; the ultrasonic vibration field then prevents new scouts from re-establishing.',
      flag: ''
    },
    ACTIVE_MULTI: {
      headline: 'Trails in multiple rooms means an established forager network. Your plan matches that scale.',
      body: 'Your [N]-device plan covers every zone where activity has been detected plus the entry points feeding it. Start with garage and exterior-door placements first \u2014 cut off recruitment before addressing the interior trails. Wipe visible trails with vinegar-water to clean surfaces; the ultrasonic vibration field then prevents scouts from re-establishing.',
      flag: ''
    },
    ACTIVE_UNLOCATED: {
      headline: 'You know they\u2019re there \u2014 let\u2019s cover every likely route until you spot the trail.',
      body: 'Your [N]-device plan covers all primary entry and food-zone placements. Start by checking these high-yield spots: behind the refrigerator, under the kitchen sink, along the toe-kick of cabinets, and around any pet water bowl. Trails are easiest to spot in low light with a flashlight skimmed along the baseboard. Garage and exterior doors are always the first placements.',
      flag: ''
    },
    PREV_HIST: {
      headline: 'You know what this looks like. Here\u2019s how to keep it from coming back.',
      body: 'Your [N]-device plan is built around the entry vectors most likely to let ants back in. Garage and exterior doors are your first line of defense \u2014 plug them in before next spring (March in the South, May in the North). Your prior experience matters here: where you found trails last time is the same place they\u2019ll try again, so prioritize that zone.',
      flag: ''
    },
    PREV_NEW: {
      headline: 'Prevention is easier than fighting active ants. Here\u2019s your starting point.',
      body: 'Your [N]-device plan focuses on the entry vectors that account for the majority of ant intrusions: the garage (if you have one) and exterior door thresholds. You don\u2019t need full interior coverage yet \u2014 perimeter deterrence is the right first investment. The substrate-vibration mechanism makes scouts turn back at your baseboards before they ever lay a trail toward your kitchen.',
      flag: ''
    },
    CHRONIC: {
      headline: 'If what you\u2019ve tried before isn\u2019t working, the issue is usually placement \u2014 not the product.',
      body: 'Most ultrasonic devices fail because they\u2019re placed in interior rooms ants are already foraging in, not at the entry vectors where scouts make the decision to recruit. Your [N]-device plan is built around the perimeter-first principle: garage and exterior-door placements come first, food-room interior coverage second. The goal is to make your home read as hostile habitat before scouts ever lay a trail \u2014 not after.',
      flag: ''
    },
    APT_GROUND: {
      headline: 'Two devices, two zones. Here\u2019s where they go.',
      body: 'Device 1: Near your unit\u2019s entry door \u2014 the gap under the threshold is the most common ant entry point in apartment units, especially older buildings with worn weather-stripping. Device 2: Kitchen \u2014 placed along the wall closest to where you\u2019ve seen trails or where pet bowls/snack stations sit.',
      flag: ''
    },
    APT_UPPER: {
      headline: 'Upper-floor units have fewer entry vectors \u2014 but ants do climb. One or two devices cover your exposure.',
      body: 'Primary placement: kitchen, along the baseboard nearest the food prep area. If you have a second device, place it near your unit\u2019s front door or in a bathroom (under-sink water sources). Shared walls are your main vulnerability \u2014 ants travel through plumbing risers and cable runs from any floor below \u2014 so seal any visible pipe or cable penetrations with caulk or foam.',
      flag: ''
    },
    MOBILE: {
      headline: 'Pier-foundation gaps are the biggest entry risk. Here\u2019s how to cover them.',
      body: 'Mobile and manufactured homes have unique entry vulnerabilities at the pier-foundation perimeter \u2014 every utility penetration through the floor is a potential ant route. Device 1: Entry door zone. Device 2: Kitchen. Device 3 (if separated rooms): Hallway midpoint to create a continuous signal corridor between zones.',
      flag: 'Pier-foundation gaps are an exclusion priority \u2014 skirting seal or hardware cloth around the base perimeter is the highest-leverage parallel action you can take. AntRx covers above the floor; sealing covers below.'
    }
  };

  /* Quiz recommends 1–15 devices. Map directly to the matching variant via window.VARIANT_MAP_BY_COUNT. */
  var MAX_VARIANT_PACK = 15;

  /* ── RATIONALE ENGINE ── */
  /* Each question maps to a function that returns an array of tally items:
     { zone: string, count: number, reason: string, type: 'add'|'neutral'|'info' } */
  var RATIONALES = {
    Q1: function(a) {
      var map = {
        A: { zone: 'Active problem detected', count: 0, reason: 'We\'ll prioritize entry points and the zone where you\'re seeing activity.', type: 'info' },
        B: { zone: 'Prevention mode', count: 0, reason: 'You\'ve dealt with this before. We\'ll focus on the entry points that let them in last time.', type: 'info' },
        C: { zone: 'Proactive protection', count: 0, reason: 'No current activity \u2014 we\'ll build perimeter coverage to keep it that way.', type: 'info' },
        D: { zone: 'Chronic problem', count: 0, reason: 'Previous methods failed. We\'ll rebuild coverage around entry points \u2014 placement is usually the issue.', type: 'info' }
      };
      return [map[a]];
    },
    Q_STATE: function(a) {
      var region = STATE_REGIONS[a] || 'plains_midwest';
      var threat = REGION_THREATS[region];
      return [{ zone: threat.zone(a), count: 0, reason: threat.reason(a), type: threat.type }];
    },
    Q2: function(a) {
      var map = {
        A: { zone: 'Single-family home', count: 0, reason: 'Standalone homes have more entry vectors (garage, doors, foundation).', type: 'info' },
        B: { zone: 'Townhouse / duplex', count: 0, reason: 'Shared walls add complexity. We\'ll cover your entry points and flag shared-wall risks.', type: 'info' },
        C: { zone: 'Apartment / condo', count: 0, reason: 'Units have fewer entry vectors than standalone homes.', type: 'info' },
        D: { zone: 'Mobile / manufactured home', count: 0, reason: 'Pier foundations create unique gaps along the perimeter.', type: 'info' }
      };
      return [map[a]];
    },
    Q3: function(a) {
      var map = {
        A: [{ zone: 'No garage', count: 0, reason: 'No garage means one fewer entry zone to cover.', type: 'neutral' }],
        B: [{ zone: 'Single-car garage', count: 2, reason: 'One device facing the garage door to repel ants entering through the gap at the base. One at the door into your home to block the transition from garage to living space.', type: 'add' }],
        C: [{ zone: 'Two-car garage', count: 2, reason: 'Two devices covering both directions \u2014 one facing the garage doors where ants enter through gaps at the base, one facing the human door into the home to prevent them crossing into your living space.', type: 'add' }],
        D: [{ zone: 'Three+ car garage', count: 3, reason: 'Larger garages need 3 devices: two covering the wider garage door span from different angles, plus one at the door into your home. More bay area means more gap surface for ants to exploit.', type: 'add' }]
      };
      return map[a];
    },
    Q3_APT: function(a) {
      if (a === 'A') {
        return [{ zone: 'Ground-floor unit', count: 2, reason: 'Ground floor units have the highest entry risk \u2014 one device at your entry door (gap at the bottom is the #1 entry point) and one in the kitchen.', type: 'add' }];
      }
      return [{ zone: 'Upper-floor unit', count: 0, reason: 'Upper floors have fewer direct entry vectors. We\'ll determine your count based on unit size.', type: 'info' }];
    },
    Q3_MOB: function(a) {
      if (a === 'A') {
        return [{ zone: 'Attached shed / structure', count: 1, reason: 'Connected structures create a sheltered pathway for ants. One device at the walkway junction blocks this route.', type: 'add' }];
      }
      return [{ zone: 'No attached structures', count: 0, reason: 'No connected outbuildings \u2014 one fewer pathway to cover.', type: 'neutral' }];
    },
    Q4: function(a) {
      var map = {
        A: [{ zone: 'Exterior door', count: 1, reason: 'One device near your exterior door. Door frames and thresholds are primary entry points \u2014 even small gaps let ants through.', type: 'add' }],
        B: [{ zone: 'Exterior doors (\u00d72)', count: 2, reason: 'One device per door. Each exterior door is an independent entry vector \u2014 ants test every gap, so every door needs coverage.', type: 'add' }],
        C: [{ zone: 'Exterior doors (\u00d73)', count: 3, reason: 'One device per door. Each exterior door is an independent entry vector.', type: 'add' }],
        D: [{ zone: 'Exterior doors (\u00d74+)', count: 4, reason: 'One device per door. With this many entry points, perimeter coverage is critical \u2014 uncovered doors become the path of least resistance.', type: 'add' }]
      };
      return map[a];
    },
    Q4B: function(a) {
      var map = {
        NONE: [{ zone: 'No overlap caught', count: 0, reason: 'Your door devices and your food-room devices are separate placements. Your count stands.', type: 'neutral' }],
        '1': [{ zone: 'Overlap caught \u2014 1 device removed', count: -1, reason: 'One door opens straight into a kitchen, pantry, or eating area. One device covers both \u2014 we removed 1.', type: 'dedup' }],
        '2': [{ zone: 'Overlap caught \u2014 2 devices removed', count: -2, reason: 'Two doors open into a food zone. Each is a single placement covering both the door and the room \u2014 we removed 2.', type: 'dedup' }],
        '3': [{ zone: 'Overlap caught \u2014 3 devices removed', count: -3, reason: 'Three doors open into a food zone. Each is a single placement \u2014 we removed 3.', type: 'dedup' }],
        '4': [{ zone: 'Overlap caught \u2014 4 devices removed', count: -4, reason: 'Four or more doors open into a food zone. Each is a single placement \u2014 we removed 4.', type: 'dedup' }]
      };
      return map[a];
    },
    Q5_APT: function(a) {
      if (state.answers.Q3_APT === 'B') {
        var ct = a === 'A' ? 1 : 2;
        return [{ zone: 'Unit rooms', count: ct, reason: ct === 1 ? 'Smaller upper-floor unit \u2014 one device in the kitchen or main living area covers your exposure.' : 'Larger upper-floor unit needs 2 devices to ensure signal reaches all rooms.', type: 'add' }];
      }
      return [{ zone: 'Room count noted', count: 0, reason: 'Your ground-floor entry coverage is already set. Room count helps confirm placement priority.', type: 'info' }];
    },
    Q5_MOB: function(a) {
      if (a === 'A') {
        return [{ zone: 'Open-plan layout', count: 2, reason: 'Open layouts need 2 devices: one at the entry door zone and one in the kitchen. Signal carries well across open space.', type: 'add' }];
      }
      return [{ zone: 'Separated layout', count: 3, reason: 'Separated rooms with hallways need 3 devices: entry door, kitchen, and a hallway midpoint to create a continuous signal corridor between zones.', type: 'add' }];
    },
    Q7: function(a) {
      var map = {
        A: [{ zone: 'Food zones (\u00d71)', count: 1, reason: 'One device in your kitchen. Sugar, grease residues, and crumbs are the only reasons ants enter homes \u2014 and they all live in the kitchen. Living rooms, bedrooms, mudrooms, and laundry rooms are transit zones, not settlement targets, so we don\'t place devices in them.', type: 'add' }],
        B: [{ zone: 'Food zones (\u00d72)', count: 2, reason: 'Two devices, one in each of your two food rooms. Ultrasonic vibration doesn\'t cross interior walls \u2014 but you don\'t need it to. Cover the rooms with food prep, food storage, or eating, and the rest of the floor takes care of itself.', type: 'add' }],
        C: [{ zone: 'Food zones (\u00d73)', count: 3, reason: 'Three devices, one in each food room. Each device covers its room and the doorway in/out, so ants can\'t reach a food zone without hitting the field. Non-food rooms get nothing \u2014 ants don\'t loiter where there\'s no food or crumbs.', type: 'add' }],
        D: [{ zone: 'Food zones (\u00d74)', count: 4, reason: 'Four devices, one in each food room. With this many distinct food prep/storage/eating zones, every one needs its own coverage \u2014 substrate vibration can\'t carry through the walls between them, so each food source needs its own deterrent.', type: 'add' }]
      };
      return map[a];
    },
    Q8: function(a) {
      var items = [];
      if (!Array.isArray(a)) return items;
      if (a.indexOf('C') !== -1) {
        items.push({ zone: 'Multi-room activity', count: 1, reason: 'Activity in multiple rooms means an established forager network. One additional device strengthens interior coverage where they\'re already moving.', type: 'add' });
      }
      if (a.indexOf('E') !== -1) {
        items.push({ zone: 'Unlocated activity', count: 1, reason: 'Since the entry point isn\'t confirmed, one extra device provides buffer coverage across likely zones until you locate the source.', type: 'add' });
      }
      if (a.indexOf('F') !== -1 && items.length === 0) {
        items.push({ zone: 'Bathroom / under-sink activity', count: 1, reason: 'Bathrooms and under-sink areas are water sources. Pharaoh ants and moisture-feeding species often prefer them over kitchens. One device in the bathroom or near the under-sink zone targets this water-route specifically.', type: 'add' });
      } else if (a.indexOf('F') !== -1) {
        items.push({ zone: 'Bathroom / water-source activity', count: 0, reason: 'Bathroom or under-sink activity noted. Your existing interior placements partially cover this. Pair with plate-moating any pet water bowls and sealing under-sink penetrations.', type: 'info' });
      }
      if (items.length === 0) {
        items.push({ zone: 'Activity zones noted', count: 0, reason: 'Your existing coverage plan addresses these areas.', type: 'neutral' });
      }
      return items;
    },
  };

  /* ── STATE THREAT DATA ── */
  /* === ANT-SPECIFIC REGIONAL DATA ===
     Eight regions, each anchored to verified species/biology rather than the
     prior rodent-template translations. Sources cross-referenced against
     extension-service & university-entomology pest profiles for each state.
     ============================================================ */
  var STATE_REGIONS = {
    // Pacific Northwest \u2014 carpenter ant country
    'Oregon': 'pnw', 'Washington': 'pnw', 'Alaska': 'pnw',
    // California & Hawaii \u2014 Argentine ant supercolonies
    'California': 'california', 'Hawaii': 'california',
    // Mountain & Southwest \u2014 drought-driven entry pressure
    'Montana': 'mountain_sw', 'Idaho': 'mountain_sw', 'Wyoming': 'mountain_sw',
    'Colorado': 'mountain_sw', 'Utah': 'mountain_sw', 'New Mexico': 'mountain_sw',
    'Arizona': 'mountain_sw', 'Nevada': 'mountain_sw',
    // Texas & Oklahoma \u2014 fire ants + tawny crazy ants
    'Texas': 'texas', 'Oklahoma': 'texas',
    // Deep South & Gulf \u2014 fire ants + ghost/white-footed (FL), year-round
    'Florida': 'deep_south', 'Georgia': 'deep_south', 'South Carolina': 'deep_south',
    'Alabama': 'deep_south', 'Mississippi': 'deep_south', 'Louisiana': 'deep_south',
    'Arkansas': 'deep_south',
    // Mid-Atlantic & Upper South \u2014 pavement + carpenter transition zone
    'North Carolina': 'mid_atlantic', 'Virginia': 'mid_atlantic', 'West Virginia': 'mid_atlantic',
    'Kentucky': 'mid_atlantic', 'Tennessee': 'mid_atlantic',
    // Northeast \u2014 pavement ant capital
    'New York': 'northeast', 'New Jersey': 'northeast', 'Pennsylvania': 'northeast',
    'Massachusetts': 'northeast', 'Connecticut': 'northeast', 'Rhode Island': 'northeast',
    'New Hampshire': 'northeast', 'Vermont': 'northeast', 'Maine': 'northeast',
    'Delaware': 'northeast', 'Maryland': 'northeast', 'District of Columbia': 'northeast',
    // Plains & Midwest \u2014 classic spring\u2013fall arc
    'North Dakota': 'plains_midwest', 'South Dakota': 'plains_midwest',
    'Nebraska': 'plains_midwest', 'Kansas': 'plains_midwest',
    'Minnesota': 'plains_midwest', 'Iowa': 'plains_midwest', 'Missouri': 'plains_midwest',
    'Michigan': 'plains_midwest', 'Wisconsin': 'plains_midwest', 'Illinois': 'plains_midwest',
    'Indiana': 'plains_midwest', 'Ohio': 'plains_midwest'
  };

  var REGION_THREATS = {
    pnw: {
      zone: function(s) { return s + ' \u2014 Carpenter Ant Country'; },
      reason: function(s) { return 'Densest carpenter ant region in the country. The wet climate keeps structural wood damp enough for galleries in wall voids, deck framing, and rim joists. Spring swarms hit May and June. AntRx makes the framing read as hostile habitat so they don\u2019t recruit there.'; },
      type: 'info'
    },
    california: {
      zone: function(s) { return s + ' \u2014 Argentine Ant Supercolony Zone'; },
      reason: function(s) { return 'Argentine ant supercolony zone. Interconnected colonies stretch miles, with no off-season. Cheap fixed-frequency ultrasonic stops working in three weeks because the colony adapts faster than the device. AntRx\u2019s adaptive frequency sweep stays effective when the pressure outside never lets up.'; },
      type: 'info'
    },
    mountain_sw: {
      zone: function(s) { return s + ' \u2014 Drought-Driven Entry Zone'; },
      reason: function(s) { return 'Drought-driven entry zone. Your house is one of few reliable water sources for half a mile. Pavement ants, odorous house ants, and red imported fire ants (AZ/NM) probe AC-line penetrations, weep holes, and door thresholds for any path to moisture. AntRx covers the entry vectors before scouts confirm a route.'; },
      type: 'info'
    },
    texas: {
      zone: function(s) { return s + ' \u2014 Fire Ant + Crazy Ant Pressure Zone'; },
      reason: function(s) { return 'Highest combined ant pressure in the country. Red imported fire ants build mounds in nearly every uncleared yard. Tawny crazy ants are spreading across the eastern half of the state. Carpenter and pharaoh ants stay year-round indoors. AntRx runs as a continuous deterrent.'; },
      type: 'info'
    },
    deep_south: {
      zone: function(s) { return s + ' \u2014 Year-Round Multi-Species Threat'; },
      reason: function(s) { return 'No cold season to break ant populations. Red imported fire ants invade year-round. Florida and the Gulf Coast also carry ghost ants and white-footed ants in walls and tight kitchen/bathroom spaces. Caribbean crazy ants are increasing in LA and MS. AntRx runs 12 months because your ant pressure does.'; },
      type: 'info'
    },
    mid_atlantic: {
      zone: function(s) { return s + ' \u2014 Carpenter & Pavement Ant Region'; },
      reason: function(s) { return 'Transition zone where pavement ants (urban indoor pest) overlap with carpenter ants in older homes with moist framing. Coastal NC and SC also carry red imported fire ants. Spring runs late March through October. AntRx covers the perimeter vectors most homeowners can\u2019t see.'; },
      type: 'info'
    },
    northeast: {
      zone: function(s) { return s + ' \u2014 Pavement Ant Capital'; },
      reason: function(s) { return 'Densest pavement ant zone in the country. Small dark ants invade kitchens and bathrooms in apartments, brownstones, and older single-family homes every spring. Carpenter ants are the second pressure in moisture-damaged wood. Spring peaks May and June. AntRx covers the foundation-and-baseboard entry vectors they exploit.'; },
      type: 'info'
    },
    plains_midwest: {
      zone: function(s) { return s + ' \u2014 Pavement + Carpenter Ant Region'; },
      reason: function(s) { return 'Classic Midwest ant pressure: pavement ants under driveways and slabs, carpenter ants in moisture-damaged basement wood, odorous house ants in kitchens, and field ants from nearby agricultural land. Activity peaks May through September. AntRx covers the entry vectors all season.'; },
      type: 'info'
    }
  };

  var _detectedState = null;

  var state = { path: null, home: null, answers: {}, history: [], currentQ: 'Q1', multiSelected: [], tallyItems: [] };

  function getTotalSteps() {
    /* Flow lengths after Q_SWARMERS removal 2026-05-07:
       APT/MOBILE non-ACTIVE: Q1, Q_STATE, Q2, Q3_APT|Q3_MOB, Q5_APT|Q5_MOB = 5
       APT/MOBILE ACTIVE:     +Q8 = 6
       SFH/TH non-ACTIVE:     Q1, Q_STATE, Q2, Q3, Q4, Q7, Q4B = 7
       SFH/TH ACTIVE:         +Q8 = 8 */
    if (state.home === 'APT' || state.home === 'MOBILE') {
      return state.path === 'ACTIVE' ? 6 : 5;
    }
    if (state.path === 'ACTIVE') return 8;
    if (state.path !== null) return 7;
    return 8; // pre-Q1 default
  }

  /* Flow (post-2026-04-30 ant-specific overhaul):
     SFH/TH:    Q1 → Q_STATE → Q2 → Q3 → Q4 → Q7 → Q4B → [if ACTIVE: Q8] → RECOMMEND  (Q6, Q_SWARMERS removed 2026-05-07)
     APT:       Q1 → Q_STATE → Q2 → Q3_APT → Q5_APT → [if ACTIVE: Q8] → RECOMMEND
     MOBILE:    Q1 → Q_STATE → Q2 → Q3_MOB → Q5_MOB → [if ACTIVE: Q8] → RECOMMEND
     Removed: Q4_APT (windows — no count impact), Q4_MOB (mobile doors — no count impact),
              Q_SURFACE (kitchens are hard floors anyway). */
  function getNextQ(qId) {
    var a = state.answers[qId];
    switch (qId) {
      case 'Q1':
        state.path = { A: 'ACTIVE', B: 'PREV_HIST', C: 'PREV_NEW', D: 'CHRONIC' }[a];
        return 'Q_STATE';
      case 'Q_STATE':
        return 'Q2';
      case 'Q2':
        state.home = { A: 'SFH', B: 'TOWNHOUSE', C: 'APT', D: 'MOBILE' }[a];
        if (a === 'C') return 'Q3_APT';
        if (a === 'D') return 'Q3_MOB';
        return 'Q3';
      case 'Q3': return 'Q4';
      case 'Q3_APT': return 'Q5_APT';
      case 'Q3_MOB': return 'Q5_MOB';
      case 'Q4': return 'Q7';
      case 'Q7': return 'Q4B';
      case 'Q4B':
        if (state.path === 'ACTIVE') return 'Q8';
        return 'RECOMMEND';
      case 'Q5_APT':
      case 'Q5_MOB':
        if (state.path === 'ACTIVE') return 'Q8';
        return 'RECOMMEND';
      case 'Q8': return 'RECOMMEND';
      default: return 'RECOMMEND';
    }
  }

  /* Device count math (post-2026-04-30 ant-specific overhaul):
     APT path: 2 (ground floor base) OR 1-2 (upper floor by room count). No carpet adder.
     MOBILE path: shed (0|1) + layout (2|3). No carpet adder.
     SFH/TH path: garage + doors - door/room dedup + ground-floor food rooms + below-grade food zone
                  + (ACTIVE only) bathroom evidence + multi-room evidence + unlocated evidence
                  + (ACTIVE only) winged-ant flag (+1 for indoor reproductive colony).
     Q_SURFACE removed: kitchens (the only ant destination rooms) are essentially always hard floor. */
  function computeDeviceCount() {
    var a = state.answers;
    if (state.home === 'APT') {
      var aptBase = a.Q3_APT === 'A' ? 2 : (a.Q5_APT === 'A' ? 1 : 2);
      var aptActive = 0;
      if (state.path === 'ACTIVE' && Array.isArray(a.Q8)) {
        if (a.Q8.indexOf('C') !== -1) aptActive += 1;
        if (a.Q8.indexOf('E') !== -1) aptActive += 1;
        if (a.Q8.indexOf('F') !== -1 && a.Q8.indexOf('C') === -1 && a.Q8.indexOf('E') === -1) aptActive += 1;
      }
      return aptBase + aptActive;
    }
    if (state.home === 'MOBILE') {
      var shed = a.Q3_MOB === 'A' ? 1 : 0;
      var layout = a.Q5_MOB === 'A' ? 2 : 3;
      var mobActive = 0;
      if (state.path === 'ACTIVE' && Array.isArray(a.Q8)) {
        if (a.Q8.indexOf('C') !== -1) mobActive += 1;
        if (a.Q8.indexOf('E') !== -1) mobActive += 1;
        if (a.Q8.indexOf('F') !== -1 && a.Q8.indexOf('C') === -1 && a.Q8.indexOf('E') === -1) mobActive += 1;
      }
      return shed + layout + mobActive;
    }
    var garage = { A: 0, B: 2, C: 2, D: 3 }[a.Q3] || 0;
    var doors = { A: 1, B: 2, C: 3, D: 4 }[a.Q4] || 0;  // D added 2026-05-07 with Q4 split into 3 / 4-or-more
    var dedup = { NONE: 0, '1': 1, '2': 2, '3': 3, '4': 4 }[a.Q4B] || 0;  // '4' added 2026-05-07 with Q4B max-out
    var foodRooms = { A: 1, B: 2, C: 3, D: 4 }[a.Q7] || 0;
    var active = 0;
    if (state.path === 'ACTIVE' && Array.isArray(a.Q8)) {
      if (a.Q8.indexOf('C') !== -1) active += 1;
      if (a.Q8.indexOf('E') !== -1) active += 1;
      if (a.Q8.indexOf('F') !== -1 && a.Q8.indexOf('C') === -1 && a.Q8.indexOf('E') === -1) active += 1;
    }
    var total = garage + doors + foodRooms + active - dedup;
    return Math.max(1, total);
  }

  function getTemplateKey() {
    var a = state.answers;
    if (state.home === 'APT') return a.Q3_APT === 'A' ? 'APT_GROUND' : 'APT_UPPER';
    if (state.home === 'MOBILE') return 'MOBILE';
    if (state.path === 'ACTIVE') {
      var ev = Array.isArray(a.Q8) ? a.Q8 : [];
      if (ev.indexOf('C') !== -1) return 'ACTIVE_MULTI';
      // E or F (or empty fallback) \u2192 UNLOCATED template (covers under-sink / behind-fridge / pet-bowl checks)
      return 'ACTIVE_UNLOCATED';
    }
    if (state.path === 'PREV_HIST') return 'PREV_HIST';
    if (state.path === 'PREV_NEW') return 'PREV_NEW';
    return 'CHRONIC';
  }

  function getVariantForCount(count) {
    var map = window.VARIANT_MAP_BY_COUNT || {};
    var clamped = Math.max(1, Math.min(MAX_VARIANT_PACK, count));
    if (map[clamped]) return map[clamped];
    for (var i = clamped; i >= 1; i--) {
      if (map[i]) return map[i];
    }
    return { id: null, sku: '', price: '', label: clamped + '-Pack' };
  }

  /* ── PERSONALIZED CTA BUILDER (#16) ── */
  // Returns the quiz-completion CTA label. Matches the page-wide "Stop the Ants"
  // framing established 2026-05-07 (six other CTA surfaces use this phrase).
  // Previously built a zone-list string ("Protect My Garage + entry doors - N Devices")
  // which contradicted the CTA reframe and referenced Q6 (basement) which was
  // removed from the quiz on 2026-05-07.
  function buildPersonalizedCTA(count) {
    return 'Stop the Ants with ' + count + (count === 1 ? ' Device' : ' Devices');
  }

  /* ── PROGRESSIVE VALUE DELIVERY (#17) ── */
  /* Milestones injected into the tally panel at key quiz moments */
  var MILESTONES = {
    // After Q3/Q3_APT/Q3_MOB - first structural data captured
    afterStructure: function() {
      var homeLabel = { SFH: 'single-family home', TOWNHOUSE: 'townhouse', APT: 'apartment', MOBILE: 'mobile home' }[state.home] || 'home';
      var riskLevel = (state.path === 'ACTIVE' || state.path === 'CHRONIC') ? 'high' : 'moderate';
      var riskColor = riskLevel === 'high' ? 'higher than average' : 'moderate';
      return {
        label: 'Early insight unlocked',
        text: 'Your ' + homeLabel + ' profile puts you at ' + riskColor + ' ant risk. We\'re building your plan around your specific entry points \u2014 not a generic recommendation.'
      };
    },
    // After Q6 or Q5_APT/Q5_MOB - interior layout captured
    afterInterior: function() {
      var count = 0;
      state.tallyItems.forEach(function(it) { count += it.count; });
      if (count === 0) return null;
      var pct = Math.min(92, Math.max(71, 60 + count * 5));
      return {
        label: 'Coverage building',
        text: count + (count === 1 ? ' device' : ' devices') + ' locked in so far \u2014 covering ' + pct + '% of your home\'s primary entry vectors. A few more details to finalize.'
      };
    }
  };

  // Track which milestones have been shown to avoid duplicates
  state.milestonesShown = {};

  function checkMilestones(qId) {
    var listEl = document.getElementById('quiz-tally-list');
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (!itemsEl) return;

    // Milestone 1: after first structural question
    if ((qId === 'Q3' || qId === 'Q3_APT' || qId === 'Q3_MOB') && !state.milestonesShown.afterStructure) {
      var m = MILESTONES.afterStructure();
      if (m) {
        var div = document.createElement('div');
        div.className = 'quiz-tally-milestone';
        div.setAttribute('data-milestone', 'afterStructure');
        div.innerHTML = '<div class="quiz-tally-milestone-label">' + m.label + '</div><div class="quiz-tally-milestone-text">' + m.text + '</div>';
        itemsEl.appendChild(div);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterStructure = true;
      }
    }

    // Milestone 2: after interior layout question
    if ((qId === 'Q6' || qId === 'Q5_APT' || qId === 'Q5_MOB') && !state.milestonesShown.afterInterior) {
      var m2 = MILESTONES.afterInterior();
      if (m2) {
        var div2 = document.createElement('div');
        div2.className = 'quiz-tally-milestone';
        div2.setAttribute('data-milestone', 'afterInterior');
        div2.innerHTML = '<div class="quiz-tally-milestone-label">' + m2.label + '</div><div class="quiz-tally-milestone-text">' + m2.text + '</div>';
        itemsEl.appendChild(div2);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterInterior = true;
      }
    }
  }

  function removeMilestonesAfter(qId) {
    // If user goes back past a milestone trigger, remove it
    var structureTriggers = ['Q3', 'Q3_APT', 'Q3_MOB'];
    var interiorTriggers = ['Q6', 'Q5_APT', 'Q5_MOB'];
    if (structureTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterStructure = false;
      var el = document.querySelector('[data-milestone="afterStructure"]');
      if (el) el.remove();
    }
    if (interiorTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterInterior = false;
      var el2 = document.querySelector('[data-milestone="afterInterior"]');
      if (el2) el2.remove();
    }
  }

  /* ── TALLY RENDERING ── */
  function updateTally() {
    var totalCount = 0;
    state.tallyItems.forEach(function(item) { totalCount += item.count; });
    if (totalCount < 0) totalCount = 0;

    var countEl = document.getElementById('quiz-tally-count');
    var prevCount = parseInt(countEl.textContent, 10);
    if (isNaN(prevCount)) prevCount = 0;

    if (totalCount < prevCount) {
      // Count is going down - animate a ticking countdown + flash
      countEl.classList.remove('flash-down');
      void countEl.offsetWidth;
      countEl.classList.add('flash-down');
      var current = prevCount;
      var step = function() {
        current -= 1;
        if (current <= totalCount) {
          countEl.textContent = totalCount;
          return;
        }
        countEl.textContent = current;
        setTimeout(step, 140);
      };
      setTimeout(step, 140);
    } else {
      countEl.textContent = totalCount;
      countEl.classList.add('bump');
      setTimeout(function() { countEl.classList.remove('bump'); }, 300);
    }

    var listEl = document.getElementById('quiz-tally-list');
    if (state.tallyItems.length === 0) {
      listEl.innerHTML = '<div class="quiz-tally-empty">Answer the first question to start building your plan.</div>';
      return;
    }

    var html = '<div class="quiz-tally-items">';
    state.tallyItems.forEach(function(item) {
      var badgeClass = item.type;
      var badgeText;
      if (item.count > 0) badgeText = '+' + item.count;
      else if (item.count < 0) badgeText = '\u2212' + Math.abs(item.count);
      else badgeText = (item.type === 'info' ? '\u2139' : '\u2013');
      var itemClass = 'quiz-tally-item' + (item.type === 'dedup' ? ' dedup-row' : '');
      html += '<div class="' + itemClass + '">' +
        '<div class="quiz-tally-badge ' + badgeClass + '">' + badgeText + '</div>' +
        '<div class="quiz-tally-detail">' +
          '<div class="quiz-tally-zone">' + item.zone + '</div>' +
          '<div class="quiz-tally-reason">' + item.reason + '</div>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    listEl.innerHTML = html;

    // scroll tally items to bottom to show latest
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (itemsEl) itemsEl.scrollTop = itemsEl.scrollHeight;
  }

  function addTallyItems(qId) {
    var fn = RATIONALES[qId];
    if (!fn) return;
    var answer = state.answers[qId];
    var items = fn(answer);
    if (items && items.length > 0) {
      // tag items with source question so we can remove on back
      items.forEach(function(it) { it._source = qId; });
      state.tallyItems = state.tallyItems.concat(items);
      updateTally();
    }
  }

  function removeTallyItemsFrom(qId) {
    state.tallyItems = state.tallyItems.filter(function(it) { return it._source !== qId; });
    updateTally();
  }

  var INSIGHTS = {
    Q3: function() { return 'Garage placement is the first line of defense \u2014 most ant entries through a garage are scout-stage, not active trail.'; },
    Q3_APT: function() { return 'Ground-floor units have higher entry exposure. Upper floors still get foragers via wall cavities and plumbing risers.'; },
    Q3_MOB: function() { return 'Pier-foundation gaps and attached sheds are the unique exposure here.'; },
    Q4: function() { return 'Skip doors that open into the garage \u2014 those are already covered. Direct-to-living-space doors are the #1 ant entry point in most homes.'; },
    Q4B: function() { return 'If a door opens straight into a kitchen, pantry, or eating area, one device covers both. We\'ll subtract to avoid duplicates.'; },
        Q7: function() { return 'Ants come for food and crumbs. Count any room where you eat, prep, or store food. Other rooms are transit zones.'; }
  };

  function renderQuestion(qId) {
    state.currentQ = qId;
    var q = QUESTIONS[qId];
    document.getElementById('quiz-question').textContent = q.text;

    var insightEl = document.getElementById('quiz-insight');
    var insightFn = INSIGHTS[qId];
    var insightText = insightFn ? insightFn() : '';
    if (insightText) { insightEl.textContent = insightText; insightEl.style.display = 'block'; }
    else { insightEl.style.display = 'none'; }

    var optHtml = '';
    var nextBtn = document.getElementById('quiz-next');

    if (q.type === 'dropdown') {
      // State dropdown rendering
      var detected = _detectedState;
      var currentVal = state.answers[qId] || detected || '';
      if (detected) {
        optHtml += '<div class="quiz-state-detected">Based on your location: <strong>' + detected + '</strong></div>';
      }
      optHtml += '<div class="quiz-state-wrap">';
      optHtml += '<select class="quiz-state-select' + (currentVal ? ' selected' : '') + '" id="quiz-state-dropdown" onchange="quizSelectState(this)">';
      optHtml += '<option value="">Select your state...</option>';
      q.options.forEach(function(st) {
        var sel = st === currentVal ? ' selected' : '';
        optHtml += '<option value="' + st + '"' + sel + '>' + st + '</option>';
      });
      optHtml += '</select></div>';
      document.getElementById('quiz-options').innerHTML = optHtml;

      // If we have a pre-filled value, store it
      if (currentVal && !state.answers[qId]) {
        state.answers[qId] = currentVal;
      }

      // Show continue button for dropdown
      nextBtn.style.display = 'inline-flex';
      nextBtn.disabled = !currentVal;
    } else {
      var filterFn = typeof q.filterOptions === 'function' ? q.filterOptions(state) : null;
      q.options.forEach(function(opt) {
        if (filterFn && !filterFn(opt)) return;
        var sel = q.multi
          ? (state.multiSelected.indexOf(opt.id) !== -1 ? ' selected' : '')
          : (state.answers[qId] === opt.id ? ' selected' : '');
        optHtml += '<button class="quiz-option' + sel + '" data-qid="' + qId + '" data-oid="' + opt.id + '" onclick="quizSelectOption(this,' + (q.multi ? 'true' : 'false') + ')"><span class="quiz-option-text">' + opt.text + '</span><span class="quiz-option-chevron">\u203a</span></button>';
      });
      document.getElementById('quiz-options').innerHTML = optHtml;

      if (q.multi) {
        nextBtn.style.display = 'inline-flex';
        nextBtn.disabled = q.allowZero ? false : (state.multiSelected.length === 0);
      } else {
        nextBtn.style.display = 'none';
        nextBtn.disabled = true;
      }
    }

    var step = state.history.length + 1;
    var total = getTotalSteps();
    // Hide "of N" until Q2 (home type) is answered \u2014 path is fully known then.
    var pathLocked = state.answers.Q2 !== undefined;
    document.getElementById('quiz-progress-label').textContent = pathLocked ? ('Step ' + step + ' of ' + total) : ('Step ' + step);
    document.getElementById('quiz-progress-fill').style.width = (Math.max(0, (step - 1) / total) * 100) + '%';

    var backBtn = document.getElementById('quiz-back');
    backBtn.style.display = state.history.length > 0 ? 'inline-flex' : 'none';
  }

  window.quizSelectOption = function(btn, isMulti) {
    var qId = btn.getAttribute('data-qid');
    var oId = btn.getAttribute('data-oid');
    if (isMulti) {
      var idx = state.multiSelected.indexOf(oId);
      if (idx === -1) { state.multiSelected.push(oId); btn.classList.add('selected'); }
      else { state.multiSelected.splice(idx, 1); btn.classList.remove('selected'); }
      document.getElementById('quiz-next').disabled = state.multiSelected.length === 0;
    } else {
      document.querySelectorAll('#quiz-options .quiz-option').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      state.answers[qId] = oId;
      setTimeout(quizAdvance, 280);
    }
  };

  window.quizSelectState = function(sel) {
    var val = sel.value;
    if (val) {
      state.answers['Q_STATE'] = val;
      sel.classList.add('selected');
      document.getElementById('quiz-next').disabled = false;
    } else {
      delete state.answers['Q_STATE'];
      sel.classList.remove('selected');
      document.getElementById('quiz-next').disabled = true;
    }
  };

  window.quizNext = function() { quizAdvance(); };

  function quizAdvance() {
    var qId = state.currentQ;
    if (QUESTIONS[qId].multi) {
      state.answers[qId] = state.multiSelected.slice();
    }
    // Add rationale items for this answered question
    addTallyItems(qId);
    // Check for progressive value delivery milestones
    checkMilestones(qId);
    state.history.push(qId);
    var nextQ = getNextQ(qId);
    if (nextQ === 'RECOMMEND') {
      showResult();
    } else {
      state.multiSelected = Array.isArray(state.answers[nextQ]) ? state.answers[nextQ].slice() : [];
      renderQuestion(nextQ);
    }
  }

  window.quizBack = function() {
    if (state.history.length === 0) return;
    var prev = state.history.pop();
    // Remove tally items and milestones from the question we're going back to
    removeTallyItemsFrom(prev);
    removeMilestonesAfter(prev);
    state.multiSelected = Array.isArray(state.answers[prev]) ? state.answers[prev].slice() : [];
    renderQuestion(prev);
  };

  function showResult() {
    var count = computeDeviceCount();
    var tmpl = TEMPLATES[getTemplateKey()];
    var variantInfo = getVariantForCount(count);
    var quizVariantId = variantInfo.id || null;
    var body = tmpl.body.replace(/\[N\]/g, count);

    var sharedWall = state.home === 'TOWNHOUSE'
      ? '<div class="quiz-flag"><strong>Shared wall note:</strong> Devices protect your unit. Shared wall cavities are an exclusion problem \u2014 not a device problem. Seal shared wall penetrations (pipe entries, utility chases) for complete coverage.</div>' : '';

    var html = '<div class="quiz-result-inner">' +
      '<div class="quiz-result-count-row">' +
        '<div class="quiz-device-count">' + count + '</div>' +
        '<div class="quiz-device-label">' + (count === 1 ? 'device' : 'devices') + ' recommended<span class="quiz-sku-label">' + variantInfo.label + '</span></div>' +
      '</div>' +
      '<h3 class="quiz-result-headline">' + tmpl.headline + '</h3>' +
      '<p class="quiz-result-body">' + body + '</p>' +
      (tmpl.flag ? '<div class="quiz-flag">' + tmpl.flag + '</div>' : '') +
      sharedWall +
      '<div class="quiz-note">Keep devices plugged in continuously \u2014 the technology works as long as it\'s powered.</div>' +
      '<button type="button" class="quiz-cta-btn" onclick="addToCartAndGo(' + quizVariantId + ')">' + buildPersonalizedCTA(count) + '</button>' +
      '<div class="free-ship-line" style="margin-top:0.35rem;margin-bottom:0.6rem;">Free shipping on orders over $55</div>' +
      '<button class="quiz-retake-btn" onclick="quizRetake()">Retake the quiz</button>' +
    '</div>';

    document.getElementById('quiz-progress-fill').style.width = '100%';
    document.getElementById('quiz-card').style.display = 'none';
    var resultEl = document.getElementById('quiz-result');
    resultEl.innerHTML = html;
    resultEl.style.display = 'block';
  }

  window.quizRetake = function() {
    state = { path: null, home: null, answers: {}, history: [], currentQ: 'Q1', multiSelected: [], tallyItems: [], milestonesShown: {} };
    document.getElementById('quiz-result').style.display = 'none';
    document.getElementById('quiz-result').innerHTML = '';
    document.getElementById('quiz-card').style.display = 'block';
    updateTally();
    renderQuestion('Q1');
  };

  // IP geolocation - pre-fill state dropdown
  (function() {
    try {
      fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data.region && data.country_code === 'US') {
            _detectedState = data.region;
          }
        })
        .catch(function() { /* silent fail - user picks manually */ });
    } catch(e) { /* AbortSignal.timeout not supported - silent fail */ }
  })();

  renderQuestion('Q1');
})();

/* ─── extracted block boundary ─── */

// Seasonal band - dynamic copy by month
(function() {
  var m = new Date().getMonth(); // 0=Jan … 11=Dec
  var heading = document.getElementById('seasonal-heading');
  var text = document.getElementById('seasonal-text');
  if (!heading || !text) return;
  var seasons = {
    // Sep–Nov: fall - colonies stockpiling
    fall: {
      heading: 'Colonies are stockpiling. Kitchens are the target.',
      text: 'As outdoor food sources dwindle, ants shift to aggressive indoor foraging through <strong>September and October</strong>. Plug AntRx in now and drive ants out before colonies stockpile in your wall cavities for winter.'
    },
    // Dec–Feb: winter - carpenter ants + spring prep
    winter: {
      heading: 'Quiet winter. Queens already laying for spring.',
      text: 'Outdoor colonies slow when soil temperatures drop, but their queens are <strong>already laying hundreds of new workers for March emergence</strong>. The homeowners who plug in AntRx now are protected before spring hits.'
    },
    // Mar–May: spring - peak emergence
    spring: {
      heading: 'Spring is when colonies wake up.',
      text: 'When soil temperatures cross <strong>50°F in late March</strong>, outdoor colonies wake up and start sending foragers indoors. Plug AntRx in before the spring wave - every new scout meets the vibration field at your baseboards before recruiting more workers.'
    },
    // Jun–Aug: summer - peak colony strength
    summer: {
      heading: 'Peak season. Peak colony strength.',
      text: 'Summer is when ant colonies are at maximum foraging strength. A backyard odorous-ant colony houses <strong>10,000 to 100,000 workers</strong>, all following the foraging routes back to the nearest food. Plug AntRx in to keep the kitchen off their map.'
    }
  };
  var s;
  if (m >= 8 && m <= 10) s = seasons.fall;       // Sep–Nov
  else if (m === 11 || m <= 1) s = seasons.winter; // Dec–Feb
  else if (m >= 2 && m <= 4) s = seasons.spring;   // Mar–May
  else s = seasons.summer;                          // Jun–Aug
  heading.textContent = s.heading;
  text.innerHTML = s.text;
})();

/* ─── extracted block boundary ─── */

/* ================================================================
   Quiz GA4 tracking
   Fires quiz funnel events to GA4 via gtag. No local storage, no
   dashboard, no beacon — GA4 is the single source of truth.
   ================================================================ */
(function() {
  /* ── GA4 dispatch ── quiz_id is attached to every event so
     multiple quizzes can share one GA4 property. */
  var QUIZ_ID = 'antrx_coverage';
  function ga4(eventName, params) {
    if (typeof gtag !== 'function') return;
    try {
      var payload = params || {};
      payload.quiz_id = QUIZ_ID;
      gtag('event', eventName, payload);
    } catch(e) {}
  }

  /* ── mid-flow state (needed for abandon + completion context) ── */
  var quizState = {
    started: false,
    currentQ: null,
    questionStartedAt: null,
    startedAt: null,
    answers: {},
    path: null,
    home: null,
    completed: false,
    abandonFired: false  /* dedupe iOS Safari double-fires of pagehide + visibilitychange:hidden */
  };

  function emitQuestionView(qId, step) {
    quizState.currentQ = qId;
    quizState.questionStartedAt = Date.now();
    ga4('quiz_question_view', { question_id: qId, step_label: step });
  }

  function emitAnswer(qId, answer, multi) {
    var ms = quizState.questionStartedAt ? (Date.now() - quizState.questionStartedAt) : null;
    quizState.answers[qId] = answer;
    if (qId === 'Q1') quizState.path = answer;
    if (qId === 'Q2') quizState.home = answer;

    var answerStr = Array.isArray(answer) ? answer.join(',') : answer;
    ga4('quiz_answer', { question_id: qId, answer: answerStr, time_on_question_ms: ms });
    if (qId === 'Q_STATE') {
      // Look up the region from STATE_REGIONS (keyed by full state name, all 50 + DC).
      // Fall back to 'unknown' (not '') so the GA4 event payload always has a defined
      // region value — easier to filter on in Looker / Explore.
      var region = (typeof STATE_REGIONS !== 'undefined' && STATE_REGIONS[answer]) ? STATE_REGIONS[answer] : 'unknown';
      ga4('quiz_state_selected', { state: answer, region: region });
    }
  }

  // MutationObserver on the question element → detect question changes = question_view
  function installQuestionObserver() {
    var qEl = document.getElementById('quiz-question');
    var stepLabelEl = document.getElementById('quiz-progress-label');
    if (!qEl) return;
    var lastText = '';
    var mo = new MutationObserver(function() {
      var text = qEl.textContent || '';
      if (text && text !== lastText) {
        lastText = text;
        var step = stepLabelEl ? stepLabelEl.textContent : '';
        /* First-text-change = quiz start. Emit Q1 view inline to fix the
           undercount: option buttons + their data-qid are often not yet
           rendered when the observer first fires, so the qId-based
           emission below was missing the initial Q1 view for ~26 of 30
           starters. The early return prevents double-firing. */
        if (!quizState.started) {
          quizState.started = true;
          quizState.startedAt = Date.now();
          ga4('quiz_start', {});
          emitQuestionView('Q1', step);
          return;
        }
        // find the actively rendered qId by reading data-qid on options or state dropdown
        var optionBtn = document.querySelector('#quiz-options .quiz-option');
        var stateDropdown = document.getElementById('quiz-state-dropdown');
        var qId = optionBtn ? optionBtn.getAttribute('data-qid') : (stateDropdown ? 'Q_STATE' : null);
        if (qId) emitQuestionView(qId, step);
      }
    });
    mo.observe(qEl, { childList: true, characterData: true, subtree: true });
  }

  // Observe the #quiz-result becoming visible → quiz_complete
  function installResultObserver() {
    var resultEl = document.getElementById('quiz-result');
    if (!resultEl) return;
    var mo = new MutationObserver(function() {
      if (resultEl.style.display !== 'none' && resultEl.offsetHeight > 0 && !quizState.completed) {
        quizState.completed = true;
        var countEl = resultEl.querySelector('.quiz-device-count');
        var skuEl = resultEl.querySelector('.quiz-sku-label');
        var deviceCount = countEl ? parseInt(countEl.textContent, 10) : null;
        var skuLabel = skuEl ? skuEl.textContent.trim() : null;
        var totalMs = quizState.startedAt ? (Date.now() - quizState.startedAt) : null;
        ga4('quiz_complete', {
          device_count: deviceCount,
          sku: skuLabel,
          quiz_path: quizState.path,
          home_type: quizState.home,
          completion_time_ms: totalMs,
          state: quizState.answers['Q_STATE'] || '',
          value: deviceCount
        });
      }
    });
    mo.observe(resultEl, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  }

  // Patch quizSelectOption + quizNext + quizBack + quizRetake
  function installFunctionHooks() {
    var origSelect = window.quizSelectOption;
    if (typeof origSelect === 'function') {
      window.quizSelectOption = function(btn, isMulti) {
        var qId = btn.getAttribute('data-qid');
        var oId = btn.getAttribute('data-oid');
        // For single-select, fire immediately; for multi, wait for Next click
        if (!isMulti && qId && oId) {
          emitAnswer(qId, oId, false);
        }
        return origSelect.apply(this, arguments);
      };
    }

    var origSelectState = window.quizSelectState;
    if (typeof origSelectState === 'function') {
      window.quizSelectState = function(sel) {
        var val = sel.value;
        if (val) {
          emitAnswer('Q_STATE', val, false);
        }
        return origSelectState.apply(this, arguments);
      };
    }

    var origNext = window.quizNext;
    if (typeof origNext === 'function') {
      window.quizNext = function() {
        // For multi-select, grab the selected options from the current question
        var qId = quizState.currentQ;
        if (qId) {
          // Handle state dropdown auto-advance via Continue button
          if (qId === 'Q_STATE') {
            var dd = document.getElementById('quiz-state-dropdown');
            if (dd && dd.value && !quizState.answers['Q_STATE']) {
              emitAnswer('Q_STATE', dd.value, false);
            }
          }
          var selected = Array.prototype.slice.call(document.querySelectorAll('#quiz-options .quiz-option.selected'))
            .map(function(b) { return b.getAttribute('data-oid'); });
          if (selected.length > 0) {
            emitAnswer(qId, selected, true);
          }
        }
        return origNext.apply(this, arguments);
      };
    }

    var origBack = window.quizBack;
    if (typeof origBack === 'function') {
      window.quizBack = function() {
        ga4('quiz_back', { from_question: quizState.currentQ });
        return origBack.apply(this, arguments);
      };
    }

    var origRetake = window.quizRetake;
    if (typeof origRetake === 'function') {
      window.quizRetake = function() {
        ga4('quiz_retake', {});
        quizState = { started: false, currentQ: null, questionStartedAt: null, startedAt: null, answers: {}, path: null, home: null, completed: false, abandonFired: false };
        return origRetake.apply(this, arguments);
      };
    }
  }

  // On unload, if a quiz is mid-flow, emit abandon (best-effort via sendBeacon).
  // iOS Safari fires both pagehide and visibilitychange:hidden on tab-switch (often
  // before actual exit), so we dedupe via quizState.abandonFired. Treat the resulting
  // event as a "left mid-flow at least once" signal, not a unique-user count.
  function installAbandonHook() {
    function abandonIfMidFlow() {
      if (quizState.started && !quizState.completed && !quizState.abandonFired && quizState.currentQ) {
        quizState.abandonFired = true;
        var abandonMs = quizState.startedAt ? (Date.now() - quizState.startedAt) : null;
        ga4('quiz_abandon', {
          last_question: quizState.currentQ,
          questions_answered: Object.keys(quizState.answers).length,
          abandon_time_ms: abandonMs,
          state: quizState.answers['Q_STATE'] || ''
        });
      }
    }
    window.addEventListener('pagehide', abandonIfMidFlow);
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') abandonIfMidFlow();
    });
  }


  /* ── boot ── */
  function boot() {
    installQuestionObserver();
    installResultObserver();
    installFunctionHooks();
    installAbandonHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();